
$(document).ready(() => {
  radioSimulation()
  focusInput()
  checkInput()
  checkForm()
  disableLetterInInput()
});

const radioSimulation = () => {
  // let searchParams = new URLSearchParams(window.location.search)

  //IE COMPATIBILITY
  $.urlParam = function (name) {
    var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (results == null) {
      return null;
    }
    else {
      return decodeURI(results[1]) || 0;
    }
  }
  let param = $.urlParam('simulation')

  if (param) {
    $('#' + param).attr('checked', true)
  }
}

const focusInput = () => {
  $('.financement input').on('focus ', (e) => {
    $(e.currentTarget).parent().addClass('active')
  })
  $('.financement input').on('focusout', (e) => {
    $(e.currentTarget).parent().removeClass('active')
  })
}

const checkInput = () => {
  $('#funding_type_list, .financement #montant').on('keyup change', (e) => {
    if ($(e.currentTarget).val()) {
      $(e.currentTarget).parent().addClass('is-ok')
    } else {
      $(e.currentTarget).parent().removeClass('is-ok')
    }
  })
}

const disableLetterInInput = () => {
  $(document).on('keyup change', '#montant', (e) => {
    newval = $(e.currentTarget).val().replace(/[^0-9.]/g, "");
    $(e.currentTarget).val(newval);
  })
}

const checkForm = () => {
  $('.financement input[type="radio"], .financement #montant').on('keyup change', (e) => {

    if ($('.financement input[type="radio"]:checked').length && $('.financement #montant').val()) {
      console.log("toto")
      $('.financement #submit').addClass('is-ok').prop('disabled', false)
    } else {
      console.log("toto2")
      $('.financement #submit').removeClass('is-ok').prop('disabled', true)
    }
  })
}